import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

export const RulesCard = ({ api, rules, reload }) => {
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(rules.join("\n"));
  const save = async () => {
    try { await axios.put(`${api}/rules`, { rules: text.split("\n") }); toast.success("Rules saved"); setEdit(false); reload(); } catch { toast.error("Could not save rules"); }
  };
  return (
    <section className="desk-card" data-testid="desk-rules">
      <div className="flex justify-between items-center"><h2>Trader rules</h2>
        {!edit && <button className="desk-btn" onClick={() => { setText(rules.join("\n")); setEdit(true); }} data-testid="desk-rules-edit">Edit</button>}</div>
      {edit ? (
        <div className="space-y-3">
          <textarea rows={7} value={text} onChange={(e) => setText(e.target.value)} className="desk-mono text-sm" data-testid="desk-rules-input" />
          <div className="flex gap-2"><button className="desk-btn primary" onClick={save} data-testid="desk-rules-save">Save</button>
            <button className="desk-btn" onClick={() => setEdit(false)} data-testid="desk-rules-cancel">Cancel</button></div>
        </div>
      ) : (
        <ol className="space-y-3 text-lg" data-testid="desk-rules-list">
          {rules.map((r, i) => <li key={`${i}-${r}`} className="flex gap-3"><span className="desk-mono text-[color:var(--gold)]">{i + 1}</span>{r}</li>)}
        </ol>
      )}
    </section>
  );
};
